package flagpack.icons.large

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathData
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import flagpack.icons.FlagIcons
import org.jetbrains.compose.ui.tooling.preview.Preview

/**
 * Equatorial Guinea Flag (32x24dp)
 *
 * - ISO Alpha-2: GQ
 * - ISO Alpha-3: GNQ
 * - ISO Numeric: 226
 *
 * @see [Flagpack](https://flagpack.xyz)
 */
public val FlagIcons.Large.EquatorialGuinea: ImageVector by lazy {
    ImageVector.Builder(
        name = "Equatorial Guinea:GQ:GNQ:226:Large",
        defaultWidth = 32.dp,
        defaultHeight = 24.dp,
        viewportWidth = 32f,
        viewportHeight = 24f
    ).apply {
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                horizontalLineToRelative(32f)
                verticalLineToRelative(24f)
                horizontalLineToRelative(-32f)
                close()
            }
        ) {
            path(fill = SolidColor(Color.White)) {
                moveTo(0f, 0f)
                horizontalLineToRelative(32f)
                verticalLineToRelative(24f)
                horizontalLineToRelative(-32f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF7FCFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                verticalLineTo(24f)
                horizontalLineTo(32f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
        }
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                verticalLineTo(24f)
                horizontalLineTo(32f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
        ) {
            path(
                fill = SolidColor(Color(0xFF009D00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                verticalLineTo(8f)
                horizontalLineTo(32f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color.White),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 8f)
                verticalLineTo(16f)
                horizontalLineTo(32f)
                verticalLineTo(8f)
                horizontalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF80000)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 16f)
                verticalLineTo(24f)
                horizontalLineTo(32f)
                verticalLineTo(16f)
                horizontalLineTo(0f)
                close()
            }
        }
        path(
            fill = SolidColor(Color(0xFF0075D5)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(0f, 0f)
            verticalLineTo(24f)
            lineTo(8f, 12.152f)
            lineTo(0f, 0f)
            close()
        }
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                verticalLineTo(24f)
                lineTo(8f, 12.152f)
                lineTo(0f, 0f)
                close()
            }
        ) {
        }
        path(
            fill = SolidColor(Color(0xFFFFD500)),
            stroke = SolidColor(Color.Black),
            strokeLineWidth = 0.05f
        ) {
            moveTo(14.57f, 8.883f)
            lineTo(14.557f, 8.886f)
            lineTo(14.548f, 8.877f)
            lineTo(14.341f, 8.686f)
            lineTo(14.315f, 8.966f)
            lineTo(14.314f, 8.979f)
            lineTo(14.302f, 8.986f)
            lineTo(14.057f, 9.123f)
            lineTo(14.316f, 9.234f)
            lineTo(14.328f, 9.24f)
            lineTo(14.33f, 9.252f)
            lineTo(14.385f, 9.528f)
            lineTo(14.571f, 9.317f)
            lineTo(14.579f, 9.307f)
            lineTo(14.592f, 9.309f)
            lineTo(14.872f, 9.342f)
            lineTo(14.728f, 9.1f)
            lineTo(14.721f, 9.088f)
            lineTo(14.727f, 9.076f)
            lineTo(14.845f, 8.821f)
            lineTo(14.57f, 8.883f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFFFFD500)),
            stroke = SolidColor(Color.Black),
            strokeLineWidth = 0.05f
        ) {
            moveTo(15.57f, 8.883f)
            lineTo(15.557f, 8.886f)
            lineTo(15.548f, 8.877f)
            lineTo(15.341f, 8.686f)
            lineTo(15.315f, 8.966f)
            lineTo(15.314f, 8.979f)
            lineTo(15.302f, 8.986f)
            lineTo(15.057f, 9.123f)
            lineTo(15.316f, 9.234f)
            lineTo(15.328f, 9.24f)
            lineTo(15.33f, 9.252f)
            lineTo(15.385f, 9.528f)
            lineTo(15.571f, 9.317f)
            lineTo(15.579f, 9.307f)
            lineTo(15.592f, 9.309f)
            lineTo(15.872f, 9.342f)
            lineTo(15.728f, 9.1f)
            lineTo(15.721f, 9.088f)
            lineTo(15.727f, 9.076f)
            lineTo(15.845f, 8.821f)
            lineTo(15.57f, 8.883f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFFFFD500)),
            stroke = SolidColor(Color.Black),
            strokeLineWidth = 0.05f
        ) {
            moveTo(16.57f, 8.883f)
            lineTo(16.557f, 8.886f)
            lineTo(16.548f, 8.877f)
            lineTo(16.341f, 8.686f)
            lineTo(16.315f, 8.966f)
            lineTo(16.314f, 8.979f)
            lineTo(16.302f, 8.986f)
            lineTo(16.057f, 9.123f)
            lineTo(16.316f, 9.234f)
            lineTo(16.328f, 9.24f)
            lineTo(16.33f, 9.252f)
            lineTo(16.385f, 9.528f)
            lineTo(16.571f, 9.317f)
            lineTo(16.579f, 9.307f)
            lineTo(16.593f, 9.309f)
            lineTo(16.872f, 9.342f)
            lineTo(16.728f, 9.1f)
            lineTo(16.721f, 9.088f)
            lineTo(16.727f, 9.076f)
            lineTo(16.845f, 8.821f)
            lineTo(16.57f, 8.883f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFFFFD500)),
            stroke = SolidColor(Color.Black),
            strokeLineWidth = 0.05f
        ) {
            moveTo(17.57f, 8.883f)
            lineTo(17.557f, 8.886f)
            lineTo(17.548f, 8.877f)
            lineTo(17.341f, 8.686f)
            lineTo(17.315f, 8.966f)
            lineTo(17.314f, 8.979f)
            lineTo(17.302f, 8.986f)
            lineTo(17.057f, 9.123f)
            lineTo(17.316f, 9.234f)
            lineTo(17.328f, 9.24f)
            lineTo(17.33f, 9.252f)
            lineTo(17.385f, 9.528f)
            lineTo(17.571f, 9.317f)
            lineTo(17.579f, 9.307f)
            lineTo(17.593f, 9.309f)
            lineTo(17.872f, 9.342f)
            lineTo(17.728f, 9.1f)
            lineTo(17.721f, 9.088f)
            lineTo(17.727f, 9.076f)
            lineTo(17.845f, 8.821f)
            lineTo(17.57f, 8.883f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFFFFD500)),
            stroke = SolidColor(Color.Black),
            strokeLineWidth = 0.05f
        ) {
            moveTo(18.57f, 8.883f)
            lineTo(18.557f, 8.886f)
            lineTo(18.548f, 8.877f)
            lineTo(18.341f, 8.686f)
            lineTo(18.315f, 8.966f)
            lineTo(18.314f, 8.979f)
            lineTo(18.302f, 8.986f)
            lineTo(18.057f, 9.123f)
            lineTo(18.316f, 9.234f)
            lineTo(18.328f, 9.24f)
            lineTo(18.33f, 9.252f)
            lineTo(18.385f, 9.528f)
            lineTo(18.571f, 9.317f)
            lineTo(18.579f, 9.307f)
            lineTo(18.593f, 9.309f)
            lineTo(18.872f, 9.342f)
            lineTo(18.728f, 9.1f)
            lineTo(18.721f, 9.088f)
            lineTo(18.727f, 9.076f)
            lineTo(18.845f, 8.821f)
            lineTo(18.57f, 8.883f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFFFFD500)),
            stroke = SolidColor(Color.Black),
            strokeLineWidth = 0.05f
        ) {
            moveTo(19.57f, 8.883f)
            lineTo(19.557f, 8.886f)
            lineTo(19.548f, 8.877f)
            lineTo(19.341f, 8.686f)
            lineTo(19.315f, 8.966f)
            lineTo(19.314f, 8.979f)
            lineTo(19.302f, 8.986f)
            lineTo(19.057f, 9.123f)
            lineTo(19.316f, 9.234f)
            lineTo(19.328f, 9.24f)
            lineTo(19.33f, 9.252f)
            lineTo(19.385f, 9.528f)
            lineTo(19.571f, 9.317f)
            lineTo(19.579f, 9.307f)
            lineTo(19.593f, 9.309f)
            lineTo(19.872f, 9.342f)
            lineTo(19.728f, 9.1f)
            lineTo(19.721f, 9.088f)
            lineTo(19.727f, 9.076f)
            lineTo(19.845f, 8.821f)
            lineTo(19.57f, 8.883f)
            close()
        }
        path(
            stroke = SolidColor(Color(0xFF373737)),
            strokeLineWidth = 0.1f
        ) {
            moveTo(15.05f, 10.05f)
            horizontalLineTo(18.95f)
            verticalLineTo(13f)
            curveTo(18.95f, 14.077f, 18.077f, 14.95f, 17f, 14.95f)
            curveTo(15.923f, 14.95f, 15.05f, 14.077f, 15.05f, 13f)
            verticalLineTo(10.05f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFF6F3E1D)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(16.726f, 11.96f)
            curveTo(16.726f, 11.96f, 16.525f, 14.325f, 16.323f, 14.469f)
            curveTo(16.122f, 14.612f, 17.288f, 14.683f, 17.4f, 14.576f)
            curveTo(17.511f, 14.469f, 16.891f, 12.541f, 17.104f, 11.96f)
            curveTo(17.318f, 11.379f, 17.661f, 11.332f, 17.661f, 11.332f)
            curveTo(17.661f, 11.332f, 17.228f, 11.24f, 17.104f, 11.414f)
            curveTo(16.981f, 11.589f, 16.612f, 11.332f, 16.612f, 11.332f)
            lineTo(16.726f, 11.96f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFF009D29)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(16.682f, 11.826f)
            horizontalLineTo(16.527f)
            curveTo(16.527f, 11.826f, 16.422f, 12.237f, 16.181f, 12.031f)
            curveTo(15.94f, 11.826f, 15.6f, 11.899f, 15.6f, 11.899f)
            curveTo(15.6f, 11.899f, 15.63f, 11.653f, 16f, 11.555f)
            curveTo(16.371f, 11.457f, 16.527f, 10.664f, 16.527f, 10.664f)
            curveTo(16.527f, 10.664f, 17.051f, 10.469f, 17.369f, 10.868f)
            curveTo(17.688f, 11.268f, 18.137f, 11.097f, 18.137f, 11.097f)
            curveTo(18.137f, 11.097f, 18.465f, 11.284f, 18.301f, 11.555f)
            curveTo(18.137f, 11.826f, 17.857f, 12.024f, 17.613f, 11.826f)
            curveTo(17.369f, 11.628f, 16.682f, 11.826f, 16.682f, 11.826f)
            close()
        }
    }.build()
}

@Preview
@Composable
private fun EquatorialGuineaPreview() {
    Box(modifier = Modifier.padding(12.dp)) {
        Image(
            imageVector = FlagIcons.Large.EquatorialGuinea,
            contentDescription = "Equatorial Guinea Flag"
        )
    }
}
